import { useTranslation } from './i18n';
import { useFreeUsageUntil } from './use-free-usage';
import { useBlackFridayCampaignEnabled } from './black-friday-flag';

/**
 * "BFCM Unlimited Credits" — the plan card's title while the campaign's free hours run, in place
 * of "Free Plan" (or the paid plan's name). Null the rest of the time, so a call site falls back to what
 * it already showed.
 *
 * Read by all three cards that name a plan: the rail's credits card, the Settings desktop card and the
 * Settings mobile card. The rest of each card is untouched — the subtitle keeps saying "Free until …",
 * the meter stays empty (nothing is being charged), and the Upgrade button stays where it is.
 *
 * **It takes the campaign spec as well as the window**, because free-usage hours are not Black Friday's
 * alone: any promo code can grant them, and a card that said "BFCM Unlimited Credits" to someone
 * who redeemed an unrelated code would be naming the wrong campaign. Both halves, or the ordinary title.
 */
export function useBlackFridayPlanTitle(): string | null {
  const { t } = useTranslation();
  const campaignOn = useBlackFridayCampaignEnabled();
  const freeUntil = useFreeUsageUntil();
  if (!campaignOn || !freeUntil) return null;
  return t('blackFriday.plan.title');
}
